module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/gallery/art-gallery-09-c4c1e46c7fe84036fe5d9916ebaac89b.jpg";